var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 7.81V16.19C22.25 19.83 20.08 22 16.44 22H8.06C4.42 22 2.25 19.83 2.25 16.19V7.81C2.25 7.3 2.29 6.81 2.38 6.36C2.89 3.61 4.92 2.01 8.02 2H16.48C19.58 2.01 21.61 3.61 22.12 6.36C22.21 6.81 22.25 7.3 22.25 7.81Z",
    fill: "#FAEF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 7.81V7.86H2.25V7.81C2.25 7.3 2.29 6.81 2.38 6.36H8.02V2H9.52V6.36H14.98V2H16.48V6.36H22.12C22.21 6.81 22.25 7.3 22.25 7.81Z",
    fill: "#121C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.69 12.72L12.61 11.52C11.84 11.08 11.1 11.02 10.52 11.35C9.94 11.68 9.62 12.36 9.62 13.24V15.64C9.62 16.52 9.94 17.2 10.52 17.53C10.77 17.67 11.05 17.74 11.34 17.74C11.74 17.74 12.17 17.61 12.61 17.36L14.69 16.16C15.46 15.72 15.88 15.1 15.88 14.43C15.88 13.76 15.45 13.17 14.69 12.72Z",
    fill: "#121C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.b8ab19685698c09416559744b90ad6dc.svg";
export { ForwardRef as ReactComponent };